import React from "react"

const IconEdit = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#F9B233"
        fillRule="evenodd"
        d="M21.455 5.416a.75.75 0 01-.096.943l-9.193 9.192a.75.75 0 01-.34.195l-3.829 1a.75.75 0 01-.915-.915l1-3.828a.778.778 0 01.161-.312L17.47 2.47a.75.75 0 011.06 0l2.829 2.828a.756.756 0 01.096.118zm-1.687.412L18 4.061l-8.518 8.518-.625 2.393 2.393-.625 8.518-8.519z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#F9B233"
        d="M19.641 17.16c.274-2.337.36-4.691.261-7.04a.403.403 0 01.117-.3l.984-.984a.198.198 0 01.338.127 45.91 45.91 0 01-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832-3.466.387-7.05.387-10.516 0-2.012-.225-3.637-1.81-3.873-3.832a45.922 45.922 0 010-10.67c.236-2.022 1.86-3.607 3.873-3.832a47.75 47.75 0 017.989-.213c.171.01.25.218.128.34l-.993.992a.402.402 0 01-.297.117 46.164 46.164 0 00-6.66.255c-1.33.148-2.396 1.198-2.55 2.516a44.421 44.421 0 000 10.32c.154 1.318 1.22 2.368 2.55 2.516 3.355.375 6.827.375 10.183 0 1.33-.148 2.395-1.198 2.55-2.516z"
      ></path>
    </svg>
  )
}

export default IconEdit
